import { device, siteColors } from "src/constants/themes";
import styled from "src/utils/styled/styled";

interface IColor {
  color: string;
}
interface IDemoDiv {
  width?: string;
  alignCenter?: boolean;
  hiddenMobile?: boolean;
  hiddenLarge?: boolean;
}

export const BorderedCard = styled.div<IColor>`
  border: 1px solid ${(props) => props.color};
  border-left: 6px solid ${(props) => props.color};
  border-radius: 5px;
`;

export const FlexCard = styled.div`
  display: flex;
  padding: 16px;
  column-gap: 10px;
  align-items: center;
  justify-content: center;
  @media ${device.tablet} {
    flex-direction: column-reverse;
  }
`;
export const SubHeader = styled.div`
  color: ${siteColors.primary};
  font-size: 16px;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-weight: 500;
`;


export const FlexImage = styled.div`
  width: 200px;
`;

export const FlexText = styled.div`
  width: 80%;
  @media ${device.tablet} {
    width: 100%;
  }
`;

export const AboutUsSubtitle = styled.div`
  font-size: 1.2146rem;
  margin-bottom: 4px;
  font-weight: 500;
`;

export const DemoTableCell = styled.td<IDemoDiv>`
    margin: 10px;
    width: ${props => props.width || '200px'};
    display: flex;
    align-items: center;
`;
export const DemoMaxTableCell = styled.td`
  width: 100%;
  margin: 10px;
`;

export const DemoRowWithHover = styled.tr`
  width: 100%;
  display: flex;
  &:nth-of-type(2n + 1) {
    background-color: ${siteColors.tableCell};
  }
  &:hover {
    background-color: ${siteColors.hover};
  }
  @media (${device.mobileM}){

  }
`;

export const DemoBox = styled.div`
  display: flex;
  padding: 10px;
  @media ${device.mobileM} {
    flex-direction: column;
  }
`;

export const DemoDiv = styled.div<IDemoDiv>`
  display: ${props => props.hiddenLarge ? 'none' : 'flex'};
  flex-direction: column;
  align-items: ${props =>  props.alignCenter ? 'center' : 'flex-start'};
  width: ${(props) => props.width || '200px'};
  justify-content: center;
  @media ${device.mobileM} {
    width: 100%;
    display: ${props => props.hiddenMobile ? 'none' : 'flex'};
    
  }

`;

